<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
        marginBottom: '20px',
        paddingBottom: '20px',
      }"
      height="80"
      card
      color="#fff"
    >
      <v-layout row align-center justify-space-between>
        <v-flex grow>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon color="#fff" medium>alarm</v-icon>
          </div>
          <h1 style="display: inline">Reporte de asistencia</h1>
        </v-flex>
        <router-link :to="{ name: 'Reports' }">
          <v-icon>close</v-icon>
        </router-link>
      </v-layout>

      <v-speed-dial
        key="1"
        absolute
        bottom
        left
        direction="bottom"
        open-on-hover
        transition="scale-transition"
        style="bottom: 0"
      >
        <template v-slot:activator>
          <v-btn color="gradiente" dark fab>
            <v-icon>more_vert</v-icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadPdf"
          >
            <v-icon>file_download</v-icon>
          </v-btn>
          <span>Descargar PDF</span>
        </v-tooltip>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadXlsx"
          >
            <v-img
              :style="{ flex: '0 1 auto' }"
              height="28px"
              width="28px"
              :src="require('@/assets/reports/IconoCSV.png')"
            />
          </v-btn>
          <span>Descargar XLSX</span>
        </v-tooltip>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadXlsModal"
          >
            <v-icon>sim_card_download</v-icon>
          </v-btn>
          <span>Exportar XLSX por fechas</span>
        </v-tooltip>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="showSettingModal"
          >
            <v-icon>settings</v-icon>
          </v-btn>
          <span>Ajuste de reportes</span>
        </v-tooltip>
      </v-speed-dial>
    </v-toolbar>
    <v-container
      fluid
      grid-list-xl
      style="
        padding: 20px;
        height: 90vh;
        overflow: scroll;
        padding-bottom: 120px !important;
      "
    >
      <v-layout row wrap>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm4 md3>
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-left="500"
                    :nudge-width="500"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    max-width="600px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Buscar"
                        class="border-container"
                        prepend-inner-icon="search"
                        clearable
                        solo
                        flat
                        hide-details
                        v-model="filters.search"
                      >
                        <template v-slot:append>
                          <v-icon v-on="on">tune</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap>
                          <!-- Level -->
                          <v-flex xs12 sm4 md6 pa-1>
                            <v-layout row>
                              <v-flex pr-1>
                                <div class="icon-select border-container">
                                  <v-icon color="primary" medium>person</v-icon>
                                </div>
                              </v-flex>
                              <v-flex pl-1>
                                <v-select
                                  multiple
                                  class="border-container"
                                  :items="filterLevels"
                                  v-model="filters.levelIds"
                                  item-text="levelName"
                                  item-value="levelId"
                                  label="Nivel"
                                  flat
                                  solo
                                  hide-details
                                  return-object
                                  no-data-text="No hay registros para filtrar"
                                  @change="filterLevel"
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- Group -->
                          <v-flex xs12 sm4 md6 pa-1>
                            <v-layout row>
                              <v-flex pr-1>
                                <div class="icon-select border-container">
                                  <v-icon color="primary" medium>person</v-icon>
                                </div>
                              </v-flex>
                              <v-flex pl-1>
                                <v-select
                                  multiple
                                  class="border-container"
                                  :items="filterGG"
                                  v-model="filters.gradeGroupIds"
                                  item-text="groupName"
                                  label="Grupo"
                                  item-value="groupId"
                                  flat
                                  solo
                                  hide-details
                                  no-data-text="No hay registros para filtrar"
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- Attendance -->
                          <v-flex xs12 sm4 md6 pa-1>
                            <v-layout>
                              <v-flex pr-1>
                                <div class="icon-select border-container">
                                  <v-icon color="primary" medium
                                    >schedule</v-icon
                                  >
                                </div>
                              </v-flex>
                              <v-flex pl-1>
                                <v-select
                                  multiple
                                  class="border-container"
                                  :items="filterAtendance"
                                  v-model="filters.attendanceTypes"
                                  item-text="type"
                                  label="Asistencia"
                                  solo
                                  flat
                                  hide-details
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- initial date -->
                          <v-flex xd12 sm12 md12 pa-1>
                            <div class="border-container px-3">
                              <v-layout row wrap align-center>
                                <v-flex xs5 sm4 pr-0>Fecha de inicio</v-flex>
                                <v-flex xs7 sm8 pl-0 ml>
                                  <v-menu
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template late v-slot:activator="{ on }">
                                      <v-text-field
                                        id="first-small"
                                        :value="momentFormatFirst"
                                        label="Fecha de inicio"
                                        prepend-icon="event"
                                        readonly
                                        solo
                                        flat
                                        hide-details
                                        v-on="on"
                                        class="padded"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      header-color="primary"
                                      color="secondary"
                                      locale="es-419"
                                      scrollable
                                      :min="firstDate"
                                      :max="today"
                                      v-model="timeFirst"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                          <!-- final date -->
                          <v-flex xd12 sm12 md12 pa-1>
                            <div class="border-container px-3">
                              <v-layout row wrap align-center>
                                <v-flex xs5 sm4 pr-0> Fecha de término</v-flex>
                                <v-flex xs7 sm8 pl-0>
                                  <v-menu
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        id="last-small"
                                        :value="momentFormatLast"
                                        label="Fecha de término"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                        solo
                                        flat
                                        hide-details
                                        class="padded"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      header-color="primary"
                                      color="secondary"
                                      locale="es-419"
                                      scrollable
                                      :min="timeFirst"
                                      :max="today"
                                      v-model="timeLast"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions
                        style="justify-content: end; margin-right: 8px"
                      >
                        <v-flex
                          xd12
                          sm7
                          md4
                          style="display: flex; justify-content: end"
                        >
                          <v-btn
                            @click="filterClear"
                            v-show="showFilter"
                            color="primary"
                          >
                            <v-icon left>close</v-icon>
                            Limpiar filtros
                          </v-btn>
                        </v-flex>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-flex>
                <v-flex
                  class="box-circle-counter"
                  v-for="attendanceCount in AttendanceCountListData"
                >
                  <p>
                    {{ attendanceCountOptions[attendanceCount.type].text }}
                  </p>
                  <v-img
                    :style="{
                      backgroundColor:
                        attendanceCountOptions[attendanceCount.type].rgb,
                      borderRadius: '50%',
                    }"
                    max-height="50"
                    max-width="50"
                  >
                    <p style="margin-top: 15px; color: white">
                      {{ attendanceCount.count }}
                    </p>
                  </v-img>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text class="px-0 py-0">
              <v-data-table
                :rows-per-page-items="[25, 50, 100]"
                rows-per-page-text="Registros por página"
                :headers="headers"
                :items="items"
                :total-items="totalItems"
                :loading="isLoadingTable"
                :pagination.sync="pagination"
                @update:pagination="customPaginator"
                no-results-text="No se encontraron coincidencias"
                no-data-text="No hay registros"
                must-sort
              >
                <template v-slot:headers="props">
                  <tr>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="header.sortable ? 'sortable_pick' : ''"
                      @click="header.sortable ? changeSort(header.value) : null"
                      :style="header.style ? header.style : 'width: 150px'"
                    >
                      {{ header.text }}
                      <SortTableArrow
                        :hide="header.sortable === false"
                        :is-active="header.value === pagination.sortBy"
                        :is-upward="pagination.descending"
                      />
                    </th>
                  </tr>
                </template>
                <v-progress-linear
                  v-slot:progress
                  color="primary"
                  indeterminate
                ></v-progress-linear>
                <template v-slot:items="props">
                  <tr>
                    <td>
                      {{
                        `${props.item.firstName ? props.item.firstName : '-'}`
                      }}
                    </td>
                    <td>
                      {{ `${props.item.lastName ? props.item.lastName : '-'}` }}
                    </td>
                    <td>
                      {{ `${props.item.level ? props.item.level : '-'}` }}
                    </td>
                    <td>
                      {{
                        `${props.item.gradeGroup ? props.item.gradeGroup : '-'}`
                      }}
                    </td>
                    <td>
                      {{ `${props.item.personId ? props.item.personId : '-'}` }}
                    </td>
                    <td>
                      {{ parseDate(props.item.dateIn) }}
                    </td>
                    <td>
                      {{ parseTimeUiDateInDateOut(props.item.dateIn) }}
                    </td>
                    <td>
                      {{ parseTimeUiDateInDateOut(props.item.dateOut) }}
                    </td>
                    <td class="custom_row">
                      <div
                        :class="`custom_pill pill_${
                          selectTypeOfDotOnAttendance(props.item.attendanceType)
                            .color
                        }-bg`"
                      >
                        <div
                          :class="`custom_pill-dot pill_${
                            selectTypeOfDotOnAttendance(
                              props.item.attendanceType
                            ).color
                          }-dot`"
                        ></div>
                        <span
                          :class="`custom_pill-text pill_${
                            selectTypeOfDotOnAttendance(
                              props.item.attendanceType
                            ).color
                          }-text`"
                        >
                          {{
                            selectTypeOfDotOnAttendance(
                              props.item.attendanceType
                            ).text
                          }}
                        </span>
                      </div>
                      <button
                        @click="changeAttendance(props.item)"
                        :class="permitsEditAttendance ? '' : 'disabled'"
                      >
                        <img
                          :src="require('@/assets/icons/pencil_alt.svg')"
                          alt=""
                          height="20px"
                          style="
                            margin-top: 5px;
                            filter: brightness(0) invert(0);
                          "
                        />
                      </button>
                    </td>
                    <td style="width: 300px; min-width: 300px">
                      <div
                        v-if="props.item.notes !== undefined"
                        style="display: grid; grid-template-columns: 200px 50px"
                      >
                        <div
                          class=""
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            line-clamp: 3;
                            -webkit-box-orient: vertical;
                          "
                        >
                          <v-tooltip top lazy max-width="300">
                            <template v-slot:activator="{ on }">
                              <div v-on="on">{{ props.item.notes }}</div>
                            </template>
                            <span>{{ props.item.notes }}</span>
                          </v-tooltip>
                        </div>
                        <div class="d-flex justify-end align-center">
                          <v-icon
                            size="19"
                            color="black"
                            @click="editNote(props.item)"
                          >
                            edit
                          </v-icon>
                          <v-icon
                            size="19"
                            color="black"
                            @click="deleteNote(props.item)"
                          >
                            delete
                          </v-icon>
                        </div>
                      </div>
                      <div v-else>
                        <span class="font-weight-medium">Agregar nota</span>
                        <br />
                        <v-btn
                          flat
                          icon
                          class="ma-0 primary white--text"
                          style="width: 20px; height: 20px"
                          @click="addNote(props.item)"
                        >
                          <v-icon size="15">add</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  <div
                    v-if="
                      (totalItems === 0 || totalItems === undefined) &&
                      showFilter === true
                    "
                  >
                    No hay registros para filtrar
                  </div>
                  <div v-else>
                    No hay registros de asistencia, ya que no cuentas con
                    horario de entrada configurado para los niveles registrados
                    <router-link :to="{ name: 'LevelsConfig' }">
                      <u> Configurar horarios </u>
                    </router-link>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <ModalNote
      v-model="note.show"
      :ok-text="note.okText"
      :text="note.item.notes"
      :id="note.item.id"
      :is-edit="note.isEdit"
      @changeNote="onChangeNote"
      edit-note-ep="reports/editNote"
      add-note-ep="reports/addNote"
    />
    <ConfirmDelete
      :show="modals.showDelete"
      title="¿Estas seguro que deseas eliminar la nota del registro?"
      description="Una vez eliminada la nota, ya no se mostrará en el registro"
      cancel-text="No, Cancelar"
      ok-text="Si, eliminar"
      @change="onConfirmDelete"
    />
    <ReportSettings
      :show="showSetting"
      title="Configuración de reporte de asistencia"
      reportSettingtype="STUDENT_ASSISTANCE"
      @closeEditSetting="onCloseEditSetting"
    />
    <DowloadXlsModal
      :isOpen="modalXls"
      :startDate="today"
      @onClose="modalXls = !modalXls"
      @onGetReport="downloadXlsReport"
      ref="dowloadXlsModalStudentAttendance"
    >
    </DowloadXlsModal>
    <EditAttendance
      v-model="modalAttendance.show"
      :student="modalAttendance.student"
      @updateAttendance="onUpdateAttendance"
    >
    </EditAttendance>
    <Error v-model="modals.showError" :text="modals.errorText"> </Error>
    <Success v-model="modals.showSuccess" :text="modals.successText"> </Success>
    <Loading v-model="modals.showLoading" text="Cargando..." />
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import {
  _genericDownloadFile,
  _isSomeDifferent,
} from '../../../../utils/genericUtils.js'
import Error from '../../../Dialogs/Error.vue'
import Loading from '../../../Dialogs/Loading.vue'
import ModalNote from '../../../Dialogs/ModalNote.vue'
import Success from '../../../Dialogs/Success.vue'
import ConfirmDelete from '../../../Dialogs/confirm_new_ui.vue'
import DowloadXlsModal from '../../../Modals/DownloadXlsModal.vue'
import ReportSettings from '../../../Modals/reportSettings.vue'
import SortTableArrow from '../../../Tools/SortTableArrow.vue'
import {
  AttendanceCount,
  AttendanceCountList,
  Student,
  filterByLevel,
  isNotEmpty,
  parseGroups,
  parseLevels,
  parseStudents,
} from '../utils.js'
import EditAttendance from './editAttendanceModal.vue'

export default {
  components: {
    DowloadXlsModal,
    EditAttendance,
    Error,
    Success,
    SortTableArrow,
    ReportSettings,
    ModalNote,
    Loading,
    ConfirmDelete,
  },
  data() {
    return {
      showSetting: false,
      noRecord: 'Sin registro',
      attendanceCountOptions: {
        ON_TIME: { text: 'Puntual', rgb: '#4b8c93' },
        LATE: { text: 'Retardo', rgb: '#fcb243' },
        ABSENCE: { text: 'Falta', rgb: '#ea5d60' },
      },
      /**@type {Array<AttendanceCount>} */
      AttendanceCountListData: [],
      modals: {
        showError: false,
        errorText: '',
        showSuccess: false,
        successText: '',
        showDelete: false,
        showLoading: false,
      },
      permitsEditAttendance: false,
      modalAttendance: {
        show: false,
        /**@type {Student} */
        student: null,
      },
      modalXls: false,
      today: moment().format('YYYY-MM-DD'),
      timeFirst: moment().format('YYYY-MM-DD'),
      timeLast: moment().format('YYYY-MM-DD'),
      limitFirstDate: new Date(
        new Date().setDate(new Date().getDate() - 30)
      ).toLocaleDateString('sv-SE'),
      today: new Intl.DateTimeFormat('fr-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(Date.now()),
      filterLevels: null,
      filterGG: [],
      selectedLevelId: null,
      selectedLevelType: null,
      filterAtendance: [
        // { type: 'Todos', value: '' },
        { type: 'Falta', value: 'ABSENCE' },
        { type: 'Retardo', value: 'LATE' },
        { type: 'Puntual', value: 'ON_TIME' },
      ],
      posibleFilters: { gradeGroups: [], levels: [] },
      filters: {
        search: '',
        attendanceTypes: '',
        gradeGroupIds: '',
        levelIds: '',
      },
      showFilter: false,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: 'NAME',
      },
      headers: [
        {
          text: 'Nombre',
          value: 'NAME',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Apellido',
          value: 'LAST_NAME',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Nivel',
          value: 'LEVEL',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Grado',
          value: 'grade',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Matrícula',
          value: 'ID',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Fecha',
          value: 'ID',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Hora de entrada',
          value: 'TIME_IN',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Hora de salida',
          value: 'TIME_OUT',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Asistencia',
          value: 'ATTENDANCE_TYPE',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Notas',
          value: 'NOTES',
          sortable: false,
          align: 'center',
          style: 'width: 300px',
        },
      ],
      isLoadingTable: false,
      items: [],
      totalItems: 0,
      note: {
        show: false,
        item: new Student({ notes: '' }),
        okText: '',
        isEdit: false,
      },
    }
  },
  created() {
    this._getStudentsAttendance(true)
  },
  async mounted() {
    this._setPermission()
    // don't call api table here, it's already called on the watch

    this.getLevelToFilter()
  },
  computed: {
    momentFormatFirst() {
      if (this.timeFirst != null) {
        return moment(this.timeFirst).format('DD/MM/YYYY')
      }
      return ''
    },
    momentFormatLast() {
      if (this.timeLast != null) {
        return moment(this.timeLast).format('DD/MM/YYYY')
      }
      return ''
    },
    ...mapGetters(['getUser', 'getBrandTZ']),
  },
  methods: {
    addNote(note) {
      this.note.isEdit = false
      this.note.okText = 'Agregar'
      this.note.item = note
      this.note.show = true
    },
    editNote(note) {
      this.note.isEdit = true
      this.note.okText = 'Guardar'
      this.note.item = note
      this.note.show = true
    },
    async onChangeNote(e) {
      if (e === undefined) return
      this.note.item.notes = e
    },
    deleteNote(note) {
      this.note.item = note
      this.modals.showDelete = true
    },
    async onConfirmDelete(e) {
      this.modals.showDelete = false
      if (e === false) return
      this.modals.showLoading = true
      try {
        await this.$store.dispatch('reports/deleteNote', this.note.item.id)
        this.modals.successText = 'Éxito al eliminar la nota'
        this.modals.showSuccess = true
      } catch (error) {
        console.log(error)
        this.modals.errorText = 'Ocurrió un error al eliminar la nota'
        this.modals.showError = true
      } finally {
        this.modals.showLoading = false
        this._getStudentsAttendance()
      }
    },
    parseDate(epochTime) {
      if (epochTime === null) return this.noRecord
      return moment(new Date(epochTime)).format('L')
    },
    onCloseEditSetting() {
      this.showSetting = false
    },
    showSettingModal() {
      this.showSetting = true
    },
    async downloadPdf() {
      const params = {
        orderBy: this.pagination.sortBy,
        orderType: this.pagination.descending ? 'DESC' : 'ASC',
        search: this.filters.search,
        offset: this._offsetHandler(),
        page: this.pagination.rowsPerPage,
        from: this.timeFirst,
        to: this.timeLast,
      }

      const isGradeGroupsSelected =
        this.filters.gradeGroupIds !== '' &&
        this.filters.gradeGroupIds !== null &&
        this.filters.gradeGroupIds !== undefined
      const isLevelSelected =
        this.filters.levelIds !== '' &&
        this.filters.levelIds !== null &&
        this.filters.levelIds !== undefined
      const isAttendanceTypeSelected =
        this.filters.attendanceTypes !== '' &&
        this.filters.attendanceTypes !== undefined &&
        this.filters.attendanceTypes !== null

      if (isAttendanceTypeSelected) {
        params.attendanceTypes = this.filters.attendanceTypes
      }
      if (isGradeGroupsSelected) {
        params.gradeGroupIds = this.filters.gradeGroupIds
      }
      if (isLevelSelected) {
        params.levelIds = this.filters.levelIds.map((e) => e.levelId)
      }

      const response = await this.$store.dispatch(
        'reports/getStudentsAttendancePdf',
        params
      )

      _genericDownloadFile({
        documentName: 'reporte.pdf',
        blob: response.data,
      })
    },
    async downloadXlsx(isModalXlsxDate = false, xlsxDates) {
      let params = {
        orderBy: this.pagination.sortBy,
        orderType: this.pagination.descending ? 'DESC' : 'ASC',
        search: this.filters.search,
        offset: this._offsetHandler(),
        page: this.pagination.rowsPerPage,
        from: this.timeFirst,
        to: this.timeLast,
      }

      const isGradeGroupsSelected =
        this.filters.gradeGroupIds !== '' &&
        this.filters.gradeGroupIds !== null &&
        this.filters.gradeGroupIds !== undefined
      const isLevelSelected =
        this.filters.levelIds !== '' &&
        this.filters.levelIds !== null &&
        this.filters.levelIds !== undefined
      const isAttendanceTypeSelected =
        this.filters.attendanceTypes !== '' &&
        this.filters.attendanceTypes !== undefined &&
        this.filters.attendanceTypes !== null

      if (isAttendanceTypeSelected) {
        params.attendanceTypes = this.filters.attendanceTypes
      }
      if (isGradeGroupsSelected) {
        params.gradeGroupIds = this.filters.gradeGroupIds
      }
      if (isLevelSelected) {
        params.levelIds = this.filters.levelIds.map((e) => e.levelId)
      }

      if (isModalXlsxDate === true) {
        params = {
          ...params,
          ...xlsxDates,
        }
      }

      const response = await this.$store.dispatch(
        'reports/getStudentsAttendanceXlsx',
        params
      )

      _genericDownloadFile({
        documentName: 'reporte.xlsx',
        blob: response.data,
      })
    },
    downloadXlsModal() {
      this.$refs.dowloadXlsModalStudentAttendance.onOpen()
      this.modalXls = true
    },
    downloadXlsReport(e) {
      this.downloadXlsx(true, { from: e.startDate, to: e.endDate })
      this.$refs.dowloadXlsModalStudentAttendance.onClose()
      this.modalXls = false
    },
    parseTimeUiDateInDateOut(epochTime = null) {
      if (epochTime === null) return this.noRecord

      let parsedTimeFormat = ''

      const tempTime = new Intl.DateTimeFormat('es-MX', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        hourCycle: 'h12',
        timeZone: this.getBrandTZ.timezone,
      })
        .format(Date.parse(new Date(epochTime)))
        .split(' ')

      parsedTimeFormat = `${tempTime[0]} ${
        tempTime[1].includes('a') ? 'am' : 'pm'
      }`

      const [time, mm_amPm] = parsedTimeFormat.split(':')
      const isAmChrome = time === '00'

      return isAmChrome ? `12:${mm_amPm}` : parsedTimeFormat
    },
    parseDateToUiText(string = '') {
      return new Intl.DateTimeFormat('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(Date.parse(string))
    },
    selectTypeOfDotOnAttendance(index = 'ON_TIME') {
      const posibleAttendance = {
        ON_TIME: { color: 'success', text: 'Puntual' },
        LATE: { color: 'warning', text: 'Retardo' },
        ABSENCE: { color: 'danger', text: 'Falta' },
      }

      return {
        color: posibleAttendance[index].color,
        text: posibleAttendance[index].text,
      }
    },
    _offsetHandler() {
      if (this.pagination.page == 1) return 0
      return (this.pagination.page - 1) * this.pagination.rowsPerPage + 1
    },
    customPaginator() {
      this._getStudentsAttendance()
    },
    async _getStudentsAttendance(isInitialStateParams = false) {
      const params = {
        orderBy: this.pagination.sortBy,
        orderType: this.pagination.descending ? 'DESC' : 'ASC',
        search: this.filters.search,
        offset: this._offsetHandler(),
        page: this.pagination.rowsPerPage,
        from: this.timeFirst,
        to: this.timeLast,
      }

      const isAttendanceTypeSelected =
        this.filters.attendanceTypes !== '' &&
        this.filters.attendanceTypes !== undefined &&
        this.filters.attendanceTypes !== null

      if (isAttendanceTypeSelected) {
        params.attendanceTypes = this.filters.attendanceTypes
      }
      if (isNotEmpty(this.filters.gradeGroupIds)) {
        params.gradeGroupIds = this.filters.gradeGroupIds
      }
      if (isNotEmpty(this.filters.levelIds)) {
        params.levelIds = this.filters.levelIds.map((e) => e.levelId)
      }

      if (isInitialStateParams === true) {
        const tempObj = structuredClone(params)
        const tempParams = Object.keys(tempObj)
          .filter((e) => tempObj[e] !== undefined)
          .map((e) => `${e}_${tempObj[e]}`)
        this.initialStateParams = tempParams
        return
      }

      const tempObj = structuredClone(params)
      const tempParams = Object.keys(params)
        .filter((e) => tempObj[e] !== undefined)
        .map((e) => `${e}_${tempObj[e]}`)

      this.showFilter = _isSomeDifferent(this.initialStateParams, tempParams)

      try {
        this.isLoadingTable = true
        const { data } = await this.$store.dispatch(
          'reports/getStudentsAttendance',
          params
        )
        this.isLoadingTable = false
        this.items = parseStudents({ students: data.data })
        this.totalItems = data.total
      } catch (error) {
        this.isLoadingTable = false
        console.log(error)
      }
      this._getStudentsAttendanceCount(params)
    },
    async _getStudentsAttendanceCount(params) {
      try {
        const { data } = await this.$store.dispatch(
          'reports/getStudentsAttendanceCount',
          params
        )
        const sortedAttendanceCountList = AttendanceCountList(data).sort(
          (a, b) => {
            if (a.type < b.type) {
              return 1
            }
            if (a.type > b.type) {
              return -1
            }
            return 0
          }
        )

        this.AttendanceCountListData = sortedAttendanceCountList
      } catch (error) {
        this.AttendanceCountListData = [
          new AttendanceCount({ type: 'ON_TIME' }),
          new AttendanceCount({ type: 'LATE' }),
          new AttendanceCount({ type: 'ABSENCE' }),
        ]
      }
    },
    _resetLevels() {
      this.filterGG = this.posibleFilters.gradeGroups
      this.filters.levelIds = ''
    },
    _resetGradeGroups() {
      this.filterLevels = this.posibleFilters.levels
      this.filters.gradeGroupIds = ''
    },
    async filterLevel() {
      if (this.filters.levelIds.length === 0) {
        this._resetLevels()
        return
      }

      const groups = filterByLevel({
        levelIds: this.filters.levelIds.map((e) => e.levelId),
        posibleGroups: this.posibleFilters.gradeGroups,
      })
      this.filterGG = groups
    },
    _setup() {
      const dateNow = new Intl.DateTimeFormat('fr-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(Date.now())
      this.today = dateNow
      this.timeFirst = dateNow
      this.timeLast = dateNow
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
      this._getStudentsAttendance()
    },
    async getLevelToFilter() {
      try {
        const { data } = await this.$store.dispatch(
          'student/getStudentsFilters'
        )
        const levels = parseLevels({ levels: data })
        const groups = parseGroups({ gradeGroups: data })

        this.filterLevels = levels
        this.filterGG = groups
        this.posibleFilters = { gradeGroups: groups, levels: levels }
      } catch (error) {
        this.posibleFilters = { gradeGroups: [], levels: [] }
      }
    },
    async filterByLevel() {
      this.isLoadingTable = true
      const query = {
        from: this.timeFirst,
        to: this.timeLast,
        levelIds: this.selectedLevelId,
      }
      try {
        this.isLoadingTable = true
        const { data } = await this.$store.dispatch(
          'reports/getStudentsAttendance',
          query
        )
        this.isLoadingTable = false
        this.items = parseStudents({ students: data.data })
        this.totalItems = data.total
        return [data, null]
      } catch (error) {
        this.isLoadingTable = false
        console.log(error)
        return [null, error]
      }
    },
    filterClear() {
      this._resetLevels()
      this._resetGradeGroups()
      this.pagination.page = 1
      this.pagination.descending = false
      this.pagination.rowsPerPage = 25
      this.pagination.sortBy = 'NAME'
      this.showFilter = false
      this.filters.search = ''
      this.filters.attendanceTypes = ''
      this.filters.gradeGroupIds = ''
      this.filters.levelIds = ''
      this.timeFirst = moment().format('YYYY-MM-DD')
      this.timeLast = moment().format('YYYY-MM-DD')
      this._getStudentsAttendance()
    },
    /**
     * @param {Student} student
     */
    changeAttendance(student) {
      if (this.permitsEditAttendance === false) return

      this.modalAttendance.show = true
      this.modalAttendance.student = structuredClone(student)
    },
    async onUpdateAttendance(value) {
      if (value === null) return

      if (value === this.modalAttendance.student.attendanceType) return

      const [dataMsg, error] = await this._updateAttendance(value)

      if (error !== null) {
        this.modals.showError = true
        this.modals.errorText = error
        return
      }

      this.modals.showSuccess = true
      this.modals.successText = dataMsg
      this._getStudentsAttendance()
    },
    /**
     *
     * @param {"ON_TIME"|"LATE, ON_TIME" | "ABSENCE"} value
     */
    async _updateAttendance(value) {
      /**
       * @typedef {{type: "ON_TIME"|"LATE, ON_TIME" | "ABSENCE"}} Type
       * @type {{id_schedule_attendance: number, body: Type}} data
       */
      const params = {
        id_schedule_attendance: this.modalAttendance.student.id,
        body: { type: value },
      }

      try {
        await this.$store.dispatch('reports/editStudentsAttendance', params)
        return ['Actualizado exitosamente.', null]
      } catch (error) {
        console.error(error.response.status)
        if (error.response.status === 404) return [null, 'Valor no permitido.']
        if (error.response.status === 404)
          return [null, 'No se encontró el registro de horario proporcionado.']
        return [null, 'Ocurrió un error']
      }
    },
    _setPermission() {
      if (this.getUser.webRole === undefined) return
      const isAdmin = this.getUser.webRole.hierachy === 0
      const allowEditAttendance = this.getUser.webRole.catalogs.filter(
        (e) => e.name === 'UPDATEATTENDANCE_REPORTS'
      )

      if (allowEditAttendance.length === 0) return
      this.permitsEditAttendance = isAdmin || allowEditAttendance.length === 1
    },
  },
  watch: {
    getUser() {
      this._setPermission()
    },
    async timeFirst() {
      if (this.timeFirst === null || this.timeLast === null) return
      const a = await this._getStudentsAttendance()
      // console.log(a)
      // call api table here
    },
    async timeLast() {
      if (this.timeFirst === null || this.timeLast === null) return
      const a = await this._getStudentsAttendance()
      // console.log(a)
      // call api table here
    },
    filters: {
      handler() {
        this._getStudentsAttendance()
      },
      deep: true,
    },
    // selectedLevelId: {
    //   handler() {
    //     this._getStudentsAttendance()
    //   },
    // },
  },
}
</script>

<style scoped>
.sortable_pick {
  cursor: pointer;
}
.box-circle-counter > div {
  margin-right: auto;
  margin-left: auto;
}
.box-circle-counter p {
  text-align: center;
  font-weight: 600;
}
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}

.icon-select {
  padding: 8px;
}

/* pill */
.pill_success-bg {
  background-color: #d1fae5;
}

.pill_success-dot {
  background-color: #34d399;
}

.pill_success-text {
  color: #065f46;
}

.pill_warning-bg {
  background-color: #fef3c7;
}

.pill_warning-dot {
  background-color: #fbbf24;
}

.pill_warning-text {
  color: #92400e;
}

.pill_danger-bg {
  background-color: #fbdfde;
}

.pill_danger-dot {
  background-color: #d92a2a;
}

.pill_danger-text {
  color: #b91b19;
}

.custom_pill {
  border-radius: 10px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  /* height: 20px; */

  padding: 2px 10px;
  height: auto;
  width: 100%;
  margin-right: 10px;
}

.custom_pill-text {
  text-transform: capitalize;
}

.custom_pill-dot {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  margin-right: 5px;
}

.custom_row {
  padding: 0;
  display: flex;
  align-items: center;
  padding: 0 !important;
  padding-right: 15px !important;
}

.disabled {
  opacity: 0.3;
  cursor: default;
}

::v-deep .v-input__prepend-outer {
  margin-right: -1px !important;
}

::v-deep .padded .v-input__slot {
  padding-left: 8px !important;
}

::v-deep .v-datatable.v-table > thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

table.v-table > thead tr {
  background-color: #dddddd;
  height: 40px;
}

::v-deep .v-datatable.v-table > tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

@media (max-width: 600px) {
  ::v-deep .v-datatable.v-table > thead {
    display: block;
  }
}
</style>
